/* @flow weak */
import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Button from 'components/Button.jsx';
import { directAddSubmit } from 'lib/directAddHelper';
import DirectAddLegalDialog from 'groups/components/DirectAddLegalDialog.jsx';
import Field from 'components/Field.jsx';
import Group from 'entities/Group';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger.jsx';
import mountTymkPrompt from 'utils/mountTymkPrompt';
import ParticipantsTableInput from 'users/components/ParticipantsTableInput.jsx';
import React from 'react';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';

class GroupInviteBulkAddTab extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
    supportSms: React.PropTypes.bool,
  };

  state = {
    participants: [],
    loading: false,
  };

  onUpdate = (participants) => {
    this.setState({ participants });
  };

  submitDirectAddParticipants = () => {
    this.setState({ loading: true });
    directAddSubmit(this.props.group, this.state.participants, (remainingParticpants) => {
      this.setState({ participants: remainingParticpants, loading: false });
    }, () => {
      this.setState({ loading: false });
    });
    mountTymkPrompt(this, 'send_invite');
  };

  submitDisabled = () => {
    const { participants } = this.state;
    return !participants || participants.filter(p => p.uid && p.valid).length === 0;
  };

  toggle = (name) => {
    this.setState({ [name]: !this.state[name] });
  };

  render() {
    const { supportSms } = this.props;

    const subtext = (
      <div>
        <Text element="p">
          Enter contact information in the space provided. You can also copy and paste from a spreadsheet.
          {' '}
          <Link href="https://youtu.be/ulfHinOT1Ws" target="_blank">
            Want to watch how?
          </Link>
        </Text>
        <Text element="p">
          Getting an error?
          {' '}
          <Link href={`${LinkConstants.ZENDESK}/articles/201816825`} target="_blank">
            Here are the reasons why
          </Link>
          {' '}
          you might not be able to add a participant.
        </Text>
      </div>
    );

    const title = supportSms ?
      'Enter phone numbers or email addresses' :
      'Enter email addresses';

    return (
      <div>
        <BoxHeader title={title} subtext={subtext} />
        <BoxBody>
          <Row size="small">
            <ParticipantsTableInput
              groupId={this.props.group.id}
              onChangeRow={this.onUpdate}
              initialRows={this.state.participants}
              supportSms={supportSms}
            />
          </Row>
          <Field>
            <Text color="thunder" size="xxsmall">
              {'By clicking "Add people," I confirm that these people gave me' +
              ' permission to send them text messages and emails. '}
              <ModalTrigger
                modal={<DirectAddLegalDialog hasChildren={this.props.group.hasChildren()} />}>
                <Link>
                  Learn more
                </Link>
              </ModalTrigger>
            </Text>
          </Field>
          <Button
            loading={this.state.loading}
            onClick={this.submitDirectAddParticipants}
            disabled={this.state.loading || this.submitDisabled()}>
            Add people
          </Button>
        </BoxBody>
      </div>
    );
  }
}

export default GroupInviteBulkAddTab;



// WEBPACK FOOTER //
// ./src/groups/components/GroupInviteBulkAddTab.jsx